import useEventListener from '@use-it/event-listener';
import { useDebouncedCallback } from 'use-debounce';
export function useDebouncedResizeHandler(resizeHandler, { debounceMs = 200 } = {}) {
    const debouncedHandleResize = useDebouncedCallback(resizeHandler, debounceMs);
    useEventListener('resize', debouncedHandleResize);
}
